module.exports = __webpack_public_path__ + "resources/4fc55ce83a90ddb8e2b1b90d56759f95.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/nemesislevel.png
// module id = 214
// module chunks = 0